import $ from "jquery";
import mixitup from "mixitup";

$(function () {
	"use strict";
	const mixContainer = document.querySelector(".mix-container");
	if (mixContainer) {
		const mixer = mixitup(".mix-container");
	}
});
